import { render } from "./PasswordReset.vue?vue&type=template&id=6e574d80&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"

import "./PasswordReset.vue?vue&type=style&index=0&id=6e574d80&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6e574d80"

export default script